import { styled } from '@linaria/react';
import { breakpoints, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;

    &[data-contained-scroll] {
      height: var(--split-height, 90vh);
      overflow: clip;
    }
  }
`;

export const LeftSide = styled.div<{ $hideOnMobile?: boolean }>`
  width: 100%;
  display: ${({ $hideOnMobile }) => ($hideOnMobile ? 'none' : 'block')};

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
    width: var(--split-left-width, 58%);
    height: var(--split-height, 90vh);
    flex-shrink: 0;
    position: sticky;
    top: var(--announcement-banner-height, 0px);
    align-self: flex-start;

    [data-contained-scroll] & {
      position: static;
      height: 100%;
      align-self: stretch;
    }
  }
`;

export const RightSide = styled.div<{
  $mobileHorizontalPadding?: string;
  $flush?: boolean;
  $flushMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${({ $mobileHorizontalPadding, $flush }) =>
    $flush ? '0' : `${space['space-600']} ${$mobileHorizontalPadding ?? space['space-400']}`};
  box-sizing: border-box;

  @media (max-width: 389px) {
    padding-left: ${({ $flush }) => ($flush ? '0' : space['space-300'])};
    padding-right: ${({ $flush }) => ($flush ? '0' : space['space-300'])};
  }
  overflow-x: clip;
  background: ${semantic.bg.canvas};
  border-radius: ${({ $flushMobile }) => ($flushMobile ? '0' : '20px 20px 0 0')};
  margin-top: ${({ $flushMobile }) => ($flushMobile ? '0' : '-24px')};
  position: relative;
  z-index: 1;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: var(--split-right-width, 42%);
    padding: ${({ $flush }) =>
      $flush ? '0' : `${space['space-800']} ${space['space-600']} ${layout.horizontalPadding}`};
    border-radius: 0;
    margin-top: 0;
    z-index: auto;
    overflow-x: visible;

    [data-contained-scroll] & {
      height: 100%;
      overflow-y: auto;
    }
  }

  @media (min-width: ${breakpoints.wide}) {
    padding: ${({ $flush }) =>
      $flush ? '0' : `${space['space-800']} ${space['space-1200']} ${layout.horizontalPadding}`};
  }
`;

export const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: var(--split-content-max-width, 480px);
  gap: var(--split-content-gap, 64px);
  flex: 1;
  min-height: 0;
`;
